import * as React from 'react';
const Film = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-film", ...props },
    React.createElement("rect", { x: "2", y: "2", width: "20", height: "20", rx: "2.18", ry: "2.18" }),
    React.createElement("line", { x1: "7", y1: "2", x2: "7", y2: "22" }),
    React.createElement("line", { x1: "17", y1: "2", x2: "17", y2: "22" }),
    React.createElement("line", { x1: "2", y1: "12", x2: "22", y2: "12" }),
    React.createElement("line", { x1: "2", y1: "7", x2: "7", y2: "7" }),
    React.createElement("line", { x1: "2", y1: "17", x2: "7", y2: "17" }),
    React.createElement("line", { x1: "17", y1: "17", x2: "22", y2: "17" }),
    React.createElement("line", { x1: "17", y1: "7", x2: "22", y2: "7" })));
export default Film;
//# sourceMappingURL=Film.js.map